// extracted by mini-css-extract-plugin
export default {"surcontainer":"addTile_surcontainer__vlPKS","container":"addTile_container__kx2Ob","flyin":"addTile_flyin__EzK8l","hold":"addTile_hold__12St2","flyout":"addTile_flyout__ezlMm"};